import { cn } from "@/lib/utils.ts";
import { ActionItem } from "./ActionItem.tsx";
import { copyAction } from "./actions.ts";
import Timestamp from "./Timestamp.tsx";
import type { ActionBarProps } from "./types.ts";

export const ActionBar = (props: ActionBarProps) => {
  const { item, hoverOnly = false, rightContent, leadingContent } = props;
  const canCopy = copyAction.show(props);

  return (
    <div
      className={cn(
        "flex flex-row items-center w-full",
        hoverOnly ? "hover-device:invisible hover-device:group-hover/message:visible" : "",
      )}
    >
      <div className="flex flex-row grow gap-1">
        {leadingContent}
        {!item.isUserMessage && canCopy && <ActionItem props={props} {...copyAction} />}
        <div className="flex flex-row grow items-center gap-1.5 text-muted-foreground text-xs justify-end">
          {rightContent}
          <Timestamp timestamp={item.date} />
          {item.isUserMessage && canCopy && <ActionItem props={props} {...copyAction} />}
        </div>
      </div>
    </div>
  );
};
